export default __webpack_public_path__ + "static/media/image03.56e871a4.jpg";